import cookie from 'js-cookie';
import { COOKIE_DOMAIN, JWT_COOKIE_NAME } from './constants';
var LOADED_KEY = 'ov-program-loaded';
var PROGRAM_KEY = 'ov-program';
var opts = {
  expires: 7,
  domain: COOKIE_DOMAIN
};
export var setProgram = function setProgram(program) {
  cookie.set(PROGRAM_KEY, JSON.stringify(program), opts);
};
export var getProgram = function getProgram() {
  var programCookie = cookie.get(PROGRAM_KEY); // Initial logging-in action has no cookies to parse.

  if (typeof programCookie !== 'string') {
    return null;
  }

  return JSON.parse(programCookie);
};
export var getProgramLoaded = function getProgramLoaded() {
  return cookie.get(LOADED_KEY) === 'true';
};
export var setProgramLoaded = function setProgramLoaded() {
  cookie.set(LOADED_KEY, 'true', opts);
};
export var getAccessToken = function getAccessToken() {
  return cookie.get(JWT_COOKIE_NAME);
};
export var setAccessToken = function setAccessToken(token) {
  cookie.set(JWT_COOKIE_NAME, token, opts);
};